import { init } from "./index";

window["LoanSenseWidget"] = { init };
